import React from 'react'

export function FeaturedProject({order, imgOrder, image, title, description, stack, git, live}) {
  return (
    <div className="project">
                <div className={"project-img " + imgOrder}>
                    <img src={image} alt="" srcset="" />
                </div>
                <div className={"project-details  " + order}>
                    <small className='fw-bold'>Featured Project</small>
                    <h4 className="project-title mb-4 text-capitalize">{title}</h4>
                    <p className="detail">{description}</p>
                    <div className="tech-stack">
                        {stack && stack.map((tool, id)=> {
                            return <span key={id} className='text-capitalize'>{tool}</span>
                        })}
                    </div>
                    <div className="links">
                        {git && <a href={git} target="_blank" rel='noreferrer'><i className="fab fa-github"></i></a>}
                        {live && <a href={live} target="_blank" rel='noreferrer'><i class="fas fa-external-link-alt"></i></a>}
                    </div>
                </div>
            </div>
 )
}
